import { HTTPVerbs as e } from "@nextgen-web-framework/core";
function r() {
  return {
    url: "/comindexedcouponas/v1/coupons-search",
    method: e.GET,
    retries: 0
  };
}
export {
  r as getUserCouponsReqObj
};
//# sourceMappingURL=couponSearchApiEndPoints.js.map
